module.exports = __webpack_public_path__ + "static/media/esselunga-512.4d77569b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/esselunga-512.png
// module id = 766
// module chunks = 0